/**
 * Deferred theme interactions (footer collapse, scroll reveal, header menu).
 */
(function () {
  'use strict';

  function initFooterMobileCollapse() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const handleCollapse = (heading) => {
      const content = heading.nextElementSibling;

      if (heading.classList.contains('block-collapsed')) {
        heading.classList.remove('block-collapsed');
        heading.setAttribute('aria-expanded', 'true');
        if (content) content.style.display = 'block';
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('aria-expanded', 'false');
        if (content) content.style.display = 'none';
      }
    };

    document.querySelectorAll('.grid .footer-block__heading').forEach((heading, index) => {
      heading.classList.add('block-collapsed');
      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.setAttribute('tabindex', '0');

      const content = heading.nextElementSibling;
      if (content) {
        content.setAttribute('id', `footer-block-index-${index}`);
        content.style.display = 'none';
        heading.setAttribute('aria-controls', `footer-block-index-${index}`);
      }

      heading.addEventListener('click', () => handleCollapse(heading));
      heading.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCollapse(heading);
        }
      });
    });
  }

  function initScrollFadeIn() {
    const scrollElements = document.querySelectorAll('.fade-in-on-scroll');
    if (!scrollElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    scrollElements.forEach((el) => observer.observe(el));
  }

  function initHeaderMenuHover() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('.header__inline-menu details').forEach((menu) => {
      const summary = menu.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });

      menu.addEventListener('mouseover', () => {
        menu.setAttribute('open', true);
      });

      menu.addEventListener('mouseleave', () => {
        menu.removeAttribute('open');
      });
    });
  }

  function initFooterScrollToTop() {
    const desktopBtn = document.querySelector('.footer-button__move-to-top-desktop');
    const mobileBtn = document.querySelector('.footer-button__move-to-top-mobile');

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (desktopBtn) desktopBtn.addEventListener('click', scrollToTop);
    if (mobileBtn) mobileBtn.addEventListener('click', scrollToTop);
  }

  function initWhatsappChatLink() {
    const openBtn = document.getElementById('openWhatsappChat');
    if (!openBtn) return;

    openBtn.addEventListener('click', () => {
      window.open(
        'https://api.whatsapp.com/send/?phone=+919343217855&text=Hello!%20I%20need%20help',
        '_blank'
      );
    });
  }

  function init() {
    initFooterMobileCollapse();
    initScrollFadeIn();
    initHeaderMenuHover();
    initFooterScrollToTop();
    initWhatsappChatLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
